module.exports = __webpack_public_path__ + "img/ranking-bg.67d0c7a8.png";